import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';
import { LoggedInGuard } from './services/security/logged-in.guard';
import { NoContentComponent, NoContentModule } from './no-content';
import { AuditPageComponent } from './pages/audit-page';
import { AuditModule } from './pages/audit-page';
import { LoginComponent } from './pages/login';
import { LoginModule } from './pages/login/login.module';

export const APP_ROUTES: Routes = [
    {path: '', redirectTo: 'audit', pathMatch: 'full', canActivate: [LoggedInGuard]},
    {path: 'login', component: LoginComponent},
    {path: 'audit', component: AuditPageComponent, canActivate: [LoggedInGuard]},
    {path: '404', component: NoContentComponent},
    {path: '**', redirectTo: '404'}
];

/**
 * `App routing module `
 *
 * By default redirects to consultation-map (AuditPageComponent)
 * For wrong url redirects to 404 page (NoContentComponent)
 */
@NgModule({
    imports: [
        RouterModule.forRoot(APP_ROUTES, {
            useHash: true,
            preloadingStrategy: PreloadAllModules
        }),
        AuditModule,
        LoginModule,
        NoContentModule
    ],
    exports: [RouterModule]
})
export class AppRoutingModule {
}



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts